import { createRequestHelper } from '@utils/swr'
import { type ECommerceGoldCartOrderDetailRequest } from '../types/apiRequest'
import { type PaymentTransactionResponse } from '../types/apiResponse'
import { type ECommerceV2Apis } from '../types/apis'

const { useRequest } = createRequestHelper<ECommerceV2Apis['get']['wordPressOrder'], PaymentTransactionResponse, ECommerceGoldCartOrderDetailRequest>({
  client: 'eCommerceV2',
  key: params => params
    ? `/${params.country_code}/payment_transactions/wordpress_order_detail?order_id=${params.order_id}&project_code=${params.project_code}&country_code=${params.country_code}`
    : null,
})

export const useApiWordPressOrder = useRequest
